import { styled } from '@linaria/react';
import { semantic, size } from '../../theme/tokens';

export const SpinnerElement = styled.span<{ $size: number }>`
  display: inline-block;
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  border: ${size.stroke['stroke-thick']} solid currentColor;
  border-top-color: transparent;
  border-radius: ${size.radius['radius-full']};
  animation: voyager-spinner-spin 0.7s linear infinite;
  color: ${semantic.text.inverse};

  @keyframes voyager-spinner-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
